import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AB384DA7-C0DA-4A68-96EA-FC54BF0EDED1
 * name checkbox-marked-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked-outline.svg
 * tags
 * - Form 
 */
export const CheckboxMarkedOutlineIcon = createSvgIcon(<><path d="M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" /></>, 'CheckboxMarkedOutlineIcon');
export default CheckboxMarkedOutlineIcon